import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import klerData from "../apis/klerData";
import uuid from "uuidv4";
import _ from "lodash";
import "./Header.css";
import * as actions from "../actions";

/* eslint-disable no-unused-vars */

import M from "materialize-css/dist/js/materialize.min.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCog,
  faExclamationCircle,
  faImages,
  faLayerGroup,
  faMapMarkerAlt,
  faPowerOff,
  faUser,
  faWindowMaximize
} from "@fortawesome/free-solid-svg-icons";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { withStyles, makeStyles } from "@material-ui/core/styles";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9"
  }
}))(Tooltip);

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: false
    };
    localStorage.setItem("loadSession", false);
  }
  componentDidMount() {
    var elem = document.querySelector(".sidenav");
    var instance = M.Sidenav.init(elem, {
      edge: "left",
      inDuration: 250
    });
    this.handleLoadPage();
  }

  checkUserSession = (user, requestedData) => {
    // console.log(localStorage.getItem("requestedData"));
    if (localStorage.getItem("loadSession") === "false") {
      // ************************
      // CHECK IF USER LOCAL SESSION EXISTS
      localStorage.setItem("loadSession", true);

      if (localStorage.getItem("UserSession")) {
        // IF YES, THAT IS TREMENDOUS... CARRY ON!
        // console.log("LOCAL DATA LOADED");
        //console.log(localStorage.getItem("SessionId"));
        //console.log(localStorage.getItem("UserSession"));
        //console.log(localStorage.getItem("SubscriptionId"));
        //console.log(localStorage.getItem("SubscriptionOid"));
        //console.log(localStorage.getItem("Business"));
        //console.log(localStorage.getItem("UserIsAdmin"));
      } else {
        // IF NO, CHECK DATABASE SESSION TABLE
        // console.log("LOCAL DATA NOT FOUND");
        klerData
          .get(
            `/UserSession?$filter=Email eq '${user.email}'&$expand=SubscriptionId&$format=json`
          )
          .then(result => {
            checkDatabaseSession(result.data.d, user);
          })
          .catch(error => console.log(error));

        const checkDatabaseSession = (data, user) => {
          if (data.length > 0) {
            // DATABASE SESSION FOUND... LOAD DATA
            // console.log("DATABASE SESSION FOUND... LOAD DATA");
            //console.log(data[0].Oid);
            //console.log(data[0].Email);
            //console.log(data[0].Email);
            //console.log(data[0].SubscriptionId);
            if (data[0].SubscriptionId) {
              localStorage.setItem(
                "SubscriptionId",
                data[0].SubscriptionId.SubscriptionId
              );
              localStorage.setItem(
                "SubscriptionOid",
                data[0].SubscriptionId.Oid
              );
              localStorage.setItem("Business", data[0].SubscriptionId.Business);
              this.setState({ business: data[0].SubscriptionId.Business });
            } else {
              localStorage.setItem("SubscriptionId", "");
              localStorage.setItem("SubscriptionOid", "");
              localStorage.setItem("Business", "");
              localStorage.setItem("UserIsAdmin", false);
              this.setState({ business: "Select a location" });
            }
            localStorage.setItem("UserSession", user.email);
            localStorage.setItem("SessionId", data[0].Oid);
          } else {
            // console.log("DATABASE SESSION NOT FOUND... CREATE DATA");
            // IF DATABASE SESSION DATA NOT EXIST... DO 1, 2, 3
            // 1.CREATE DATABASE RECORD...
            // 2.SET LOCAL SESSION...
            // 3.RELOAD DATA...
            let sessionData = [];
            sessionData += `{Email: "${user.email}"}`;
            // console.log(sessionData);
            klerData
              .post(`/UserSession`, sessionData)
              .then(result => {
                checkDatabaseSession(result.data.d);
              })
              .catch(error => console.log(error));
          }
        };
      }
    }
  };

  _checkSubscription = _.memoize(user => {
    // ************************
    // CHECK IF USER SUBSCRIPTION EXISTS
    klerData
      .get(
        `/UserAccess?$filter=Email eq '${user.email}'&$expand=SubscriptionId&$format=json`
      )
      .then(result => {
        checkUserExists(result.data.d);
      })
      .catch(error => console.log(error));
    const checkUserExists = data => {
      if (data.length > 0) {
        // CHECK BUSINESS NAME
        // console.log(data[0]);
        localStorage.setItem("UserIsAdmin", data[0].Admin);
        // localStorage.setItem("UserBusiness", data[0].SubscriptionId.Business);
      } else {
        if (this.state.account !== true) {
          const newId = uuid();
          // console.log("NEED TO CREATE SUBSCRIPTION");

          // CREATE SUBSCRIPTION
          let createSubscription = "";
          createSubscription += "{";
          createSubscription += 'SubscriptionId: "' + newId + '",';
          createSubscription += 'Email: "' + user.email + '"';
          createSubscription += "}";
          // console.log("SUBSCRIPTION");
          // console.log(createSubscription);
          klerData
            .post(`/Subscription`, createSubscription)
            .then(result => {
              // console.log("SUBSCRIPTION CREATED");
            })
            .catch(error => console.log(error));

          // SELECT SUBSCRIPTION ID
          klerData
            .get(
              `/Subscription?$filter=SubscriptionId eq '${newId}'&select=Oid&$format=json`
            )
            .then(result => {
              createUser(result.data.d[0]);
            })
            .catch(error => console.log(error));

          this.setState({
            account: true
          });
        }
      }
    };

    const createUser = data => {
      // CREATE USER ACCOUNT
      let createUserAccess = "";
      createUserAccess += "{";
      createUserAccess +=
        'SubscriptionId@odata.bind: "Subscription(' + data.Oid + ')",';
      createUserAccess += 'Email: "' + user.email + '",';
      createUserAccess += "Admin: true";
      createUserAccess += "}";
      // console.log("USER ACCOUNT");
      // console.log(createUserAccess);
      klerData
        .post(`/UserAccess`, createUserAccess)
        .then(result => {
          // console.log("ACCOUNT CREATED");
        })
        .catch(error => console.log(error));
    };
  });

  handleLogout = () => {
    localStorage.clear();
    // console.log("Log Out");
  };

  handleLoadPage = () => {
    this.props.fetchSubscription(this.props.auth.googleId);
    if (
      localStorage.getItem("UserBusiness") === "" ||
      localStorage.getItem("UserBusiness") === null
    ) {
      this.props.history.push("/account");
    }
  };

  render() {
    if (this.props.auth) {
      this._checkSubscription(this.props.auth);
      this.checkUserSession(this.props.auth, this.state.requestedData);
    }

    let businessName = "";

    if (localStorage.getItem("Business") && businessName === "") {
      businessName = localStorage.getItem("Business");
    } else {
      businessName = "Edit Locations";
    }

    const menuMenus = () => {
      let options = [];
      if (localStorage.getItem("Business") !== "") {
        options = (
          <li>
            <Link to="/menus" className="sidenav-close">
              <FontAwesomeIcon icon={faWindowMaximize} size="lg" />
              Menus
            </Link>
          </li>
        );
      }
      return options;
    };

    const menuMedia = () => {
      let options = [];
      if (localStorage.getItem("Business") !== "") {
        options = (
          <li>
            <Link to="/menus/media" className="sidenav-close">
              <FontAwesomeIcon icon={faImages} size="lg" />
              Media
            </Link>
          </li>
        );
      }
      return options;
    };

    const menuGroups = () => {
      let options = [];
      if (localStorage.getItem("Business") !== "") {
        options = (
          <li>
            <Link to="/menus/groups" className="sidenav-close">
              <FontAwesomeIcon icon={faLayerGroup} size="lg" />
              Groups
            </Link>
          </li>
        );
      }
      return options;
    };

    const menuConfiguration = () => {
      let options = [];
      if (localStorage.getItem("Business") !== "") {
        options = (
          <li>
            <Link to="/menus/config" className="sidenav-close">
              <FontAwesomeIcon icon={faCog} size="lg" />
              Configuration
            </Link>
          </li>
        );
      }
      return options;
    };

    const tooltipAccount = () => {
      let tooltip = [];
      if (localStorage.getItem("NeverTrue")) {
        tooltip = (
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">Missing Requirements</Typography>
                {"Please enter your "}
                <u>{"name"}</u> {"and"} <u>{"business"}</u>.
              </React.Fragment>
            }
          >
            <Button className="pull-right">
              <FontAwesomeIcon
                icon={faExclamationCircle}
                size="lg"
                className="warning pull-right"
              />
            </Button>
          </HtmlTooltip>
        );
      }
      return tooltip;
    };

    return (
      <div className="header-component">
        <nav className="nav-wrapper">
          <Link
            to="#"
            className="sidenav-trigger brand-logo"
            data-target="slide-out"
          >
            <FontAwesomeIcon icon={faBars} size="lg" />
          </Link>
          <img
            src={require("../assets/kler-apps-logo.png")}
            alt="KLER Apps"
            className="header-logo"
          />
        </nav>
        <ul className="sidenav sidenav-fixed dark" id="slide-out">
          <li>
            <img
              src={require("../assets/kler-apps.png")}
              alt="KLER Apps"
              className="kler-logo sidenav-logo"
            />
          </li>
          <li>
            <div className="divider"></div>
          </li>
          <li>
            <Link to="/" className="sidenav-close">
              <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" />
              {businessName}
            </Link>
          </li>
          <li>
            <div className="divider"></div>
          </li>
          {menuMenus()}
          {menuMedia()}
          {menuGroups()}
          {menuConfiguration()}
          <li>
            {tooltipAccount()}
            <Link to="/account" className="sidenav-close">
              <FontAwesomeIcon icon={faUser} size="lg" />
              Account
            </Link>
          </li>
          <li>
            <div className="divider"></div>
          </li>
          <li>
            <a href="/api/logout" onClick={this.handleLogout}>
              <FontAwesomeIcon icon={faPowerOff} size="lg" /> Logout
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    session: state.session
  };
}

export default connect(
  mapStateToProps,
  actions
)(withRouter(Header));
